import { axiosAppClient, posAxiosClient } from '@kinderlabs-pos/apis/axios';

export const getDdiziRecentHistoryAsync =
	(rootUrl: string) =>
	async ({ ddiziId }: { ddiziId: string }) =>
		(
			await posAxiosClient.get<DdiziRecentHistoryType>(
				`${rootUrl}/pos-bff/ddizi/${ddiziId}/history/recent`,
				{
					params: {
						ddiziId,
					},
				}
			)
		).data;

const DdiziStatusTypeArray = ['RENTAL', 'RETURN'] as const;
type DdiziStatusType = (typeof DdiziStatusTypeArray)[number];
export type DdiziRecentHistoryType = {
	id: number;
	ddiziId: string;
	beaconTagId: string;
	status: DdiziStatusType;
	created: Date;
	storeId: number;
};
